import { styled } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'

export const PreviewDialogContainer = styled(Dialog)(({ theme }) => ({
  margin: theme.spacing(1),
  height: `calc(100% - ${theme.spacing(2)})`
}))
